import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class BlockHomeEvenements {
  constructor() {
    this._init();
  }

  _init() {
    const swiper = new Swiper('.home-evenements__swiper', {
      modules: [Navigation],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1025: {
          slidesPerView: 'auto',
          spaceBetween: 24,
        },
      },
    });
    // Sélectionne tous les boutons des catégories et les items à afficher
    const categoryButtons = document.querySelectorAll<HTMLButtonElement>(
      '.home-evenements__category'
    );
    const items = document.querySelectorAll<HTMLElement>('.home-evenements__item');

    // Ajoute un événement de clic à chaque bouton de catégorie
    categoryButtons.forEach(button => {
      button.addEventListener('click', () => {
        const selectedCategory = button.getAttribute('data-categorie');

        categoryButtons.forEach(btn => btn.classList.remove('home-evenements__category--active'));
        button.classList.add('home-evenements__category--active');

        // Affiche ou masque les items en fonction de la catégorie
        items.forEach(item => {
          const itemCategories = item.getAttribute('data-categories') || '';

          // Si "all" est sélectionné, affiche tous les items
          if (selectedCategory) {
            if (selectedCategory === 'all') {
              item.style.display = 'block';
              item.classList.remove('swiper-slide-hidden');
              item.classList.add('swiper-slide');
            } else {
              // Sinon, vérifie si l'item contient la catégorie sélectionnée
              if (itemCategories.includes(selectedCategory)) {
                item.style.display = 'block';
                item.classList.remove('swiper-slide-hidden');
                item.classList.add('swiper-slide');
              } else {
                item.style.display = 'none';
                item.classList.add('swiper-slide-hidden');
                item.classList.remove('swiper-slide');
              }
            }
          }
        });
        swiper.update();
      });
    });
  }
}
export const blockHomeEvenements = new BlockHomeEvenements();
